import React, { useEffect, useState } from "react";
import { X, CalendarClock, Filter } from "lucide-react";
import { api } from "@/lib/api";

export function YesterdayModal({ date, showT, showV, fmt, onClose, onFilter }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/tahsilat", { params: { from_date: date, to_date: date } })
      .then((r) => setRows((Array.isArray(r.data) ? r.data : r.data.rows || []).filter((x) => x.tahsilat_tarihi === date)))
      .catch(() => setRows([]));
  }, [date]);
  const tr = date.split("-").reverse().join(".");
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/50 flex items-center justify-center p-4" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[85vh] flex flex-col" data-testid="yesterday-modal">
        <div className="p-4 border-b border-slate-200 flex items-center gap-2">
          <CalendarClock size={16} />
          <h3 className="font-bold text-slate-900 flex-1">Dünkü Tahsilatlar · {tr}</h3>
          <button type="button" onClick={onFilter} data-testid="yesterday-filter-table"
            className="inline-flex items-center gap-1 text-xs font-semibold bg-slate-900 text-white px-2.5 py-1.5 rounded-lg hover:bg-slate-800">
            <Filter size={12} /> Tabloda göster
          </button>
          <button onClick={onClose} data-testid="yesterday-modal-close" className="p-1 rounded hover:bg-slate-100"><X size={16} /></button>
        </div>
        <div className="overflow-auto">
          {rows === null ? <div className="p-6 text-sm text-slate-500">Yükleniyor…</div> : rows.length === 0 ? (
            <div className="p-6 text-sm text-slate-500" data-testid="yesterday-empty">{tr} tarihinde tahsilat yok.</div>
          ) : (
            <table className="w-full text-sm">
              <thead className="text-[11px] uppercase tracking-wider text-slate-500 bg-slate-50 sticky top-0">
                <tr><th className="px-3 py-2 text-left">Müvekkil</th><th className="px-3 py-2 text-left">Föy / Dosya</th><th className="px-3 py-2 text-left">Borçlu</th>
                  {showT && <th className="px-3 py-2 text-right">Tahsilat</th>}{showV && <th className="px-3 py-2 text-right">Vekalet</th>}</tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-t border-slate-100" data-testid={`yesterday-row-${r.id}`}>
                    <td className="px-3 py-2 font-semibold text-slate-900">{r.muvekkil || "—"}</td>
                    <td className="px-3 py-2 text-slate-600">{r.icra_foy || "—"}{r.dosya_no ? ` · ${r.dosya_no}` : ""}</td>
                    <td className="px-3 py-2 text-slate-600">{r.musteri || "—"}</td>
                    {showT && <td className="px-3 py-2 text-right font-mono-tab">{fmt(r.tahsilat_miktari)} ₺</td>}
                    {showV && <td className="px-3 py-2 text-right font-mono-tab">{fmt(r.vekalet_ucreti)} ₺</td>}
                  </tr>
                ))}
              </tbody>
              {(showT || showV) && (
                <tfoot><tr className="border-t-2 border-slate-200 font-bold bg-slate-50">
                  <td className="px-3 py-2" colSpan={3}>Toplam · {rows.length} kayıt</td>
                  {showT && <td className="px-3 py-2 text-right font-mono-tab">{fmt(rows.reduce((s, r) => s + (Number(r.tahsilat_miktari) || 0), 0))} ₺</td>}
                  {showV && <td className="px-3 py-2 text-right font-mono-tab">{fmt(rows.reduce((s, r) => s + (Number(r.vekalet_ucreti) || 0), 0))} ₺</td>}
                </tr></tfoot>
              )}
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
